import { DatePicker } from 'antd';
import CustomBarChartSales from 'base/ui/components/CustomChart/BarChart/barChartSales';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';

type SalesTabProp = {
  customerSegmentationId: string;
  customerSegmentationName: string;
};

// TAB DOANH SỐ
function SalesTab(props: SalesTabProp) {
  const { customerSegmentationId, customerSegmentationName } = props;
  const { t } = useTranslation();

  const [dataChart, setDataChart] = useState<number[]>([]);
  const [dataLable, setDataLable] = useState<string[]>([]);

  const [valueYear, setValueYear] = useState(dayjs().format('YYYY'))

  const getDataChart = async () => {
    await customerSegmentPresenter.getDataChartRevenueCustomerSegment(customerSegmentStore, customerSegmentationId, Number(valueYear));
    if (customerSegmentStore.dataChartRevenue.isSuccess) {
      const chart = customerSegmentStore.dataChartRevenue.data;
      if (chart.length) {
        setDataChart(chart.map((c) => c.total));
        setDataLable(chart.map((c) => c.monthCreate));
      }
    }
  }

  useEffect(() => {
    getDataChart();
  }, [valueYear]);

  return (
    <div className="mt-3">
      <div className='flex justify-end'>
        <DatePicker
          defaultValue={dayjs()}
          onChange={(value, dateString) => {
            setValueYear(dateString)
          }} picker='year' />
      </div>

      <CustomBarChartSales
        color={['#016F81']}
        yAxisName={false}
        // title={t('segment.ds-chart')}
        title={'Doanh số phân khúc theo tháng'}
        subTitle={'Customer segment: ' + customerSegmentationName}
        data={[
          {
            name: '',
            total: dataChart,
          },
        ]}
        label={dataLable}
        rotateLabel
      // className={'!h-full'}
      />
    </div>
  );
}

export default observer(SalesTab);
